class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    
    // SEPET İÇİN ÖZEL KONTROL - cart-notification varsa farklı davran
    const isCartModal = this.querySelector('.cart-notification, .cart-drawer, [data-cart-drawer]');
    
    if (!isCartModal) {
      // Arama modal'ı için normal davranış
      const closeButton = this.querySelector('button[type="button"]');
      if (closeButton) {
        closeButton.addEventListener('click', this.close.bind(this));
      }
    } else {
      // SEPET modal'ı için - close butonunu farklı bul
      const closeButton = this.querySelector('.cart-notification__close, .cart-drawer__close, button[aria-label*="Close"]');
      if (closeButton) {
        closeButton.addEventListener('click', this.close.bind(this));
      }
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer && this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    const details = event.target.closest('details');
    if (!details) return;
    
    if (details.hasAttribute('open')) {
      this.close();
    } else {
      this.open(event);
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) {
      this.close(false);
    }
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    
    const details = event.target.closest('details');
    if (details) {
      details.setAttribute('open', true);
    }
    
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    // SEPET KONTROLÜ
    const isCartModal = this.querySelector('.cart-notification, .cart-drawer, [data-cart-drawer]');
    
    if (!isCartModal) {
      // Arama modal'ı için focus trap
      const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
      const focusInput = this.detailsContainer.querySelector('input:not([type="hidden"])');
      
      if (typeof trapFocus === 'function' && focusContainer) {
        trapFocus(focusContainer, focusInput);
      } else if (focusInput) {
        setTimeout(() => focusInput.focus(), 100);
      }
    }
  }

  close(focusToggle = true) {
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(focusToggle ? this.summaryToggle : null);
    }
    
    if (this.detailsContainer) {
      this.detailsContainer.removeAttribute('open');
    }
    
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);